// Development: http://localhost:5000
// Combat mode: https://hqua0323033.online-vm.com

const BACKEND_URL = "https://hqua0323033.online-vm.com"

export default BACKEND_URL  